import MuiPopper, { PopperProps } from '@mui/material/Popper'

function Popper(props: PopperProps) {
  return <MuiPopper {...props} />
}

export { Popper }
